<style src='style.scss'>

</style>

<article class="{wrapperClass}">
  <header class="mbsc-col-12">
    {#if mode === 'short'}
    <h1>Renueva tu membresía</h1>
    {:else}
    <h1>Nuestros planes</h1>
    {/if}
    {#if mode === 'short'}
    <p>No importa en que momento realices la renovación, el tiempo de tu membresía se acumulará al de tu membresía actual.</p>
    <p>Cada semana agregamos 4 nuevas sesiones para que te mantengas siempre actualizado.</p>
    {:else}
    <p>Con un solo pago tendrás acceso a todas las sesiones de todas las disciplinas, sin restricciones.</p>
    <p>Además, cada semana agregamos 4 nuevas sesiones para que te mantengas siempre actualizado.</p>
    {/if}
  </header>
  <section class="mbsc-col-12">
    <div class="mbsc-grid">
      <div class="mbsc-row mbsc-no-padding">
        <div class="mbsc-col-sm-12 {className}">
          <div data-collapsible class="mbsc-card-pricing">
            <div class="mbsc-card-header">
              <div class="mbsc-card-title">Mensualidad</div>
              <p class="mbsc-txt-muted">Todas nuestras clases por solo <del>$812.00</del> <strong>$243.60</strong><br> MXN IVA incluido</p>
            </div>
            <div class="mbsc-card-content">
              <div class="mbsc-form-group-title">Incluye:</div>
              <ul class="mbsc-cloak d-ns-plans">
                <li>Acceso a todo nuestro catálogo durante un mes</li>
                <li>Agregamos cuatro sesiones nuevas cada semana</li>
                <li>Una sola membresía que puedes compartir con tu familia.</li>
                <li>El precio incluye IVA, <a target="_blank" href="/contacto/">contáctanos</a> para solicitar tu factura.</li>
                <li class="mbsc-align-center">
                  <button on:click={checkoutMonthly} class="mbsc-button mbsc-btn-primary monthly-payment">Comprar ahora</button>
                  <label>Código
                    <input name="monthly_code" class="monthly_code" type="text" placeholder="Código de descuento" value="" />
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mbsc-col-sm-12 {className}">
          <div data-collapsible data-open class="mbsc-card-pricing">
            <div class="mbsc-card-header">
              <div class="mbsc-card-title">Anualidad</div>
              <p class="mbsc-txt-muted">Una año de acceso a todas nuestras clases <del>$8,120.00</del><br><strong>$2,436.00</strong><br> MXN IVA incluido</p>
            </div>
            <div class="mbsc-card-content">
              <div class="mbsc-form-group-title">Incluye:</div>
              <ul class="mbsc-cloak d-ns-plans">
                <li>Ahorra dos meses comparado con el plan mensual.</li>
                <li>Acceso a todo nuestro catálogo durante un año</li>
                <li>Agregamos dieciseis sesiones nuevas cada mes, esto es más de 200 nuevas sesiones con tu plan anual.</li>
                <li>Una sola membresía que puedes compartir con tu familia.</li>
                <li>El precio incluye IVA, <a target="_blank" href="/contacto/">contáctanos</a> para solicitar tu factura.</li>
                <li class="mbsc-align-center">
                  <button on:click={checkoutYearly} class="mbsc-button mbsc-btn-primary yearly-payment">Comprar ahora</button>
                  <label>Código
                    <input name="yearly_code" class="yearly_code" type="text" placeholder="Código de descuento" value="" />
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mbsc-col-sm-12 {className}">
          <div data-collapsible class="mbsc-card-pricing">
            <div class="mbsc-card-header">
              <div class="mbsc-card-title">Subscríbete con Paypal</div>
              <p class="mbsc-txt-muted">Membresía mensual por solo <strong>$203.00</strong>MXN al mes IVA incluido</p>
            </div>
            <div class="mbsc-card-content">
              <div class="mbsc-form-group-title">Incluye:</div>
              <ul class="mbsc-cloak d-ns-plans">
                <li>Pagarás $203.00 cada mes con cargo a tu cuenta Paypal.</li>
                <li>Los mismos beneficios del plan mensual</li>
                <li>Una membresía que puedes compartir con toda tu familia.</li>
                <li>El precio incluye IVA, <a target="_blank" href="/contacto/">contáctanos</a> para solicitar tu factura.</li>
                <li class="mbsc-align-center">
                  <p>Realiza ahora tu pago con Paypal</p>
                  <PaypalCheckout></PaypalCheckout>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mbsc-row">
        <p class="mbsc-col-12">* Las sesiones tienen una duración de 20 a 30 minutos cada una; cada semana se agregarán nuevas sesiones.</p>
      </div>
    </div>
  </section>
</article>

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';
  import { loadStripe } from '@stripe/stripe-js';
  import { Navigation, Stripe } from '@Services';

  import PaypalCheckout from '@Components/PaypalCheckout/index.svelte';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  const dispatch = createEventDispatcher();

  export let mode = 'long';

  let className = mode === 'long' ? 'mbsc-col-md-3' : 'mbsc-col-md-4';
  let wrapperClass = mode === 'long' ? 'mbsc-row' : '';

  let checkoutMonthly = () => {
    document.querySelector('.monthly-payment').disabled = true;
    const code = document.querySelector('.monthly_code').value;
    if (DEBUG) console.log('Monthly code: ' + code);
    if (code == '') {
      Navigation.goTo('checkoutMonthly');
    } else {
      Stripe.validateCoupon(null, code).then(async (response)=>{
        if (response.status === 200) {
          if ((response.discountInfo.amount > 0) && (response.discountInfo.recurrence === 'monthly')) {
            mobiscroll.alert({
              title: '¡Cupón aplicado!',
              message: 'Tu descuento del ' + response.discountInfo.amount + '% ha sido aplicado a tu membresía mensual.',
              okText: 'Pagar',
              callback: async () => {
                let stripeSessionId = response.session.id;
                const stripe = await loadStripe('pk_live_krwg6YfJKkxHhwhSwhsKpDrP002CPU8eSh');
                const {error} = stripe.redirectToCheckout({
                  sessionId: stripeSessionId
                });
              },
            });
          }else{
            mobiscroll.alert({
              title: 'Cupon inválido',
              message: 'El cupón ha expirado o es inválido',
              callback: () => {
                document.querySelector('.monthly-payment').disabled = false;
              },
            });
          }
        }else{
          mobiscroll.alert({
            title: 'Cupon inválido',
            message: 'El cupón ha expirado o es inválido',
            callback: () => {
              document.querySelector('.monthly-payment').disabled = false;
            },
          });
        }
      }).catch(error => {
        console.error(error);
        mobiscroll.alert({
          title: 'Cupon inválido',
          message: 'El cupón ha expirado o es inválido',
          callback: () => {
            document.querySelector('.monthly-payment').disabled = false;
          },
        });
      });
    }
  };
  let checkoutYearly = () => {
    document.querySelector('.yearly-payment').disabled = true;
    const code = document.querySelector('.yearly_code').value;
    if (DEBUG) console.log('Yearly code: ' + code);
    if (code == '') {
      Navigation.goTo('checkoutYearly');
    } else {
      Stripe.validateCoupon(null, code).then(async (response)=>{
        if (response.status === 200) {
          if ((response.discountInfo.amount > 0) && (response.discountInfo.recurrence === 'yearly')) {
            mobiscroll.alert({
              title: '¡Cupón aplicado!',
              message: 'Tu descuento del ' + response.discountInfo.amount + '% ha sido aplicado a tu membresía anual.',
              okText: 'Pagar',
              callback: async () => {
                let stripeSessionId = response.session.id;
                const stripe = await loadStripe('pk_live_krwg6YfJKkxHhwhSwhsKpDrP002CPU8eSh');
                const {error} = stripe.redirectToCheckout({
                  sessionId: stripeSessionId
                });
              },
            });
          }else{
            mobiscroll.alert({
              title: 'Cupon inválido',
              message: 'El cupón ha expirado o es inválido',
              callback: () => {
                document.querySelector('.yearly-payment').disabled = false;
              },
            });
          }
        }else{
          mobiscroll.alert({
            title: 'Cupon inválido',
            message: 'El cupón ha expirado o es inválido',
            callback: () => {
              document.querySelector('.yearly-payment').disabled = false;
            },
          });
        }
      }).catch(error => {
        console.error(error);
        mobiscroll.alert({
          title: 'Cupon inválido',
          message: 'El cupón ha expirado o es inválido',
          callback: () => {
            document.querySelector('.yearly-payment').disabled = false;
          },
        });
      });
    }
  };

  onMount(async () =>{
    mobiscroll.card('.mbsc-card-pricing', {theme: 'd-ns'});

    mobiscroll.listview('.d-ns-plans', {});
  });
</script>
